// extracted by mini-css-extract-plugin
module.exports = {"button":"GenericButton_button__qaC1S","small":"GenericButton_small__22V3T","outlined":"GenericButton_outlined__2Ct1d"};